import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DamacIslandsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const amenities = [
    {
      title: "Central Hub Fountain",
      description: "A stunning centerpiece fountain that serves as the heart of the community, creating a mesmerizing focal point surrounded by elegant landscaping and seating areas.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-01-Central_hub_fountain_2.jpg"
    },
    {
      title: "Water Platforms",
      description: "Exclusive water platforms offering residents unique waterfront experiences, perfect for relaxation, social gatherings, and enjoying the serene island atmosphere.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-02-Water_platforms_2.jpg"
    },
    {
      title: "Lagoon Waterfalls",
      description: "Spectacular lagoon waterfalls that create a tropical paradise atmosphere, providing both visual beauty and the soothing sounds of cascading water throughout the community.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-04-Lagoon_waterfalls_2.jpg"
    },
    {
      title: "Aqua Park",
      description: "A world-class aqua park featuring thrilling water slides, lazy rivers, and family-friendly pools, offering endless entertainment for residents of all ages.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-05-Aqua_park_2.jpg"
    },
    {
      title: "Jungle River",
      description: "An adventurous jungle river experience that winds through lush tropical landscaping, offering a unique way to explore the natural beauty of the island community.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-06-Jungle_river_2.jpg"
    },
    {
      title: "Jungle Swing",
      description: "Exciting jungle swing attractions that provide thrilling entertainment for children and families, set amidst the natural island environment.",
      image: "/damac/Damac Island/DAMAC_Islands-Amenities-07-Jungle_swing_2.jpg"
    }
  ];

  const featuredProjects = [
    {
      name: "Island Residences",
      location: "Dubai Islands, Dubai",
      price: "From AED 1,500,000",
      type: "Premium Apartments",
      image: "/damac/Damac Island/DAMAC_Islands-Gallery-15.jpg"
    },
    {
      name: "Island Villas",
      location: "Dubai Islands, Dubai",
      price: "From AED 3,200,000",
      type: "Luxury Villas",
      image: "/damac/Damac Island/DAMAC_Islands-Homepage_Hero_16x9.jpg"
    }
  ];

  const faqs = [
    {
      question: "Where is DAMAC Islands located?",
      answer: "DAMAC Islands is located in Dubai Islands, offering exclusive waterfront living with stunning views and premium amenities."
    },
    {
      question: "What types of properties are available at DAMAC Islands?",
      answer: "The development offers premium apartments and luxury villas, all designed with waterfront living in mind and featuring high-end finishes and amenities."
    },
    {
      question: "What makes DAMAC Islands unique?",
      answer: "DAMAC Islands stands out with its exclusive island location, world-class aqua park, jungle river experiences, and premium waterfront amenities that create a truly unique living experience."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative w-full h-screen flex flex-col items-center justify-center overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover z-0"
          poster="/damac/Damac Island/DAMAC_Islands-Homepage_Hero_16x9.jpg"
          controls={false}
          disablePictureInPicture
          disableRemotePlayback
          onLoadStart={() => console.log('Video loading started')}
          onCanPlay={() => console.log('Video can play')}
          onError={(e) => console.log('Video error:', e)}
        >
          <source src="/damac/Damac Island/Damac_island_Hero_video_16X9.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
        <div className="relative z-20 w-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl md:text-6xl font-light mb-4 text-white font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>DAMAC ISLANDS</h1>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>ABOUT DAMAC ISLANDS</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
              Elite Waterfront Collection - Premium villas, semi-detached villas, and townhouses on private islands, offering the ultimate in exclusive waterfront living.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Private Islands</h3>
              <p className="text-gray-600">Exclusive location</p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Premium Villas</h3>
              <p className="text-gray-600">Luxury waterfront homes</p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">World-Class Amenities</h3>
              <p className="text-gray-600">Aqua park & entertainment</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Destination Section */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>The Destination</h2>
        </div>
        
        {amenities.map((amenity, index) => (
          <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index < amenities.length - 1 ? 'mb-20' : ''}`}>
            {index % 2 === 0 ? (
              // Image Left, Text Right
              <>
                <div className="relative">
                  <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
                </div>
                <div className="text-left">
                  <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                </div>
              </>
            ) : (
              // Text Left, Image Right
              <>
                <div className="text-left">
                  <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                </div>
                <div className="relative">
                  <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
                </div>
              </>
            )}
          </div>
        ))}
      </section>

      {/* Featured Projects */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>FIND YOUR ISLAND HOME</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {featuredProjects.map((project, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.name}</h3>
                  <p className="text-gray-600 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.location}</p>
                  {project.price && (
                    <p className="text-green-600 font-semibold mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.price}</p>
                  )}
                  {project.type && (
                    <p className="text-gray-500 text-sm mb-4 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.type}</p>
                  )}
                  <Link 
                    to="/contact" 
                    className="inline-block px-6 py-3 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans" 
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  >
                    EXPLORE
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>FREQUENTLY ASKED QUESTIONS</h2>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.question}</h3>
                <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>GET IN TOUCH</h2>
            <p className="text-lg text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
              Ready to discover your perfect island home at DAMAC Islands? Contact us today.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
              ></textarea>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
                className="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
              />
              <label className="ml-2 text-sm text-gray-700 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                I agree to receive updates on WhatsApp
              </label>
            </div>
            <div className="text-center">
              <button
                type="submit"
                className="px-8 py-4 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default DamacIslandsPage; 